import { Card } from '@hivebrite/design-system/Card';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const LoginWrapper = ({ children }) => (
  <Grid>
    <Row>
      <Col
        offset={({ numCols }) => ({
          _: 0,
          m: 2 / numCols,
          l: 3 / numCols,
          xl: 4 / numCols,
        })}
        width={({ numCols }) => ({
          _: 12 / numCols,
          m: 8 / numCols,
          l: 6 / numCols,
          xl: 4 / numCols,
        })}
      >
        <Card>{children}</Card>
      </Col>
    </Row>
  </Grid>
);

export default LoginWrapper;
